import Headingsss from '../../assets/images/banner2.jpg';



function Headings() {
  return (
    <div className="container-fluid ">
 

    <h1 className="heading"> Current Giveaways</h1>

</div>
  );
}

export default Headings;
